import React, { useCallback, useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { oktaAuthHandler, type IAuthPermission } from '@choreograph/authjs'

export interface IWppPermissionedComponent {
  permissions?: IAuthPermission | IAuthPermission[] | (() => boolean | undefined)
  fallback?: React.ReactNode
  subscribe?: number
  children: React.ReactNode
}

export const WppPermissionedComponent: React.FunctionComponent<IWppPermissionedComponent> = (props) => { /* istanbul ignore next */
  const {
    permissions = [],
    children,
    subscribe = 0,
    fallback = <></>
  } = props
  const isPermissioned = Array.isArray(permissions) ? permissions.length > 0 : !!permissions
  const [allClaimsVerified, setAllClaimsVerified] = useState<boolean | undefined>(isPermissioned ? undefined : true)

  const checkClaims = useCallback(async (_permissions) => {
    if (!isPermissioned) {
      setAllClaimsVerified(true)
    } else if (typeof _permissions === 'function') {
      setAllClaimsVerified(_permissions())
    } else if (Array.isArray(_permissions)) {
      setAllClaimsVerified(await oktaAuthHandler.checkAllPermissions(_permissions))
    } else {
      setAllClaimsVerified(await oktaAuthHandler.checkPermission(_permissions))
    }
  }, [isPermissioned])

  useEffect(() => {
    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
    checkClaims(permissions)
    let interval
    if (subscribe && isPermissioned) {
      interval = setInterval(() => checkClaims(permissions), subscribe)
    }
    return () => clearInterval(interval)
  }, [subscribe, isPermissioned, permissions, checkClaims])

  if (allClaimsVerified === true) {
    return children
  } else if (allClaimsVerified === false) {
    return fallback
  } else {
    return <div className='route-loading-icon'><LoadingOutlined /></div>
  }
}
export default WppPermissionedComponent
